import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { BUTTON_TYPES } from 'src/editor-v3/components/buttons/button/Button.constants';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { Illustration } from '@photosi/rn-components/illustration/Illustration';
import { ILLUSTRATION_NAMES } from '@photosi/rn-components/illustration/illustration.helper';
import { View } from 'react-native';
import { TestIDs } from 'src/constants/testIDs.constants';
import BaseModal from '../../base-modal/BaseModal';
import { DynamicModalProps } from '../DynamicModal.types';
import { Neutrals } from 'src/theme-v2/colors';

export const ModalOverLimitProducts = observer(
  ({
    type,
    dynamicModalVisible,
    dynamicModalLayer: { id, productLimit, onPressAddBox, onPressRemoveProduct, groupWithLimit },
  }: DynamicModalProps) => {
    const { i18n } = useStore();

    return (
      <BaseModal
        testID={TestIDs.OVER_LIMIT_PRODUCTS}
        modalWidth={658}
        closeOnClickOutside={false}
        modalIcon={
          <View style={{ width: 100, height: 100 }}>
            <Illustration name={ILLUSTRATION_NAMES.AddImage} />
          </View>
        }
        title={i18n.t(`modal-over-limit-products:title_${groupWithLimit}`, { limit: productLimit })}
        description={i18n.t(`modal-over-limit-products:description_${groupWithLimit}`)}
        discardText={i18n.t('modal-over-limit-products:remove')}
        confirmText={i18n.t(`modal-over-limit-products:add_${groupWithLimit}`)}
        handleDiscard={onPressRemoveProduct}
        handleConfirm={onPressAddBox}
        primaryButtonProps={{
          iconName: ICON_NAMES.Cart,
          iconStyle: { width: 24, height: 24, color: Neutrals.main.White },
          type: BUTTON_TYPES.ICON_LEFT,
        }}
        isVisible={dynamicModalVisible}
        type={type}
        id={id}
      />
    );
  },
);
